import React from 'react'

const BuildQuery = (props: { buildQueryText: string }) => {
    return (
        <div className="padding-small" style={{ wordBreak: 'break-all' }}>
            {props.buildQueryText}
        </div>
    )
}

export default BuildQuery
